import { jsx } from "react/jsx-runtime";
// src/ZepIcon.tsx
const getDimension = (size) => {
	switch (size) {
		case "2xs": return 14;
		case "xs": return 16;
		case "sm": return 20;
		case "md": return 24;
		case "lg": return 28;
		case "xl": return 32;
	}
};
const ZepIcon = (IconComponent) => {
	const Icon = (props) => /* @__PURE__ */ jsx(IconComponent, {
		...props,
		width: props.size ? getDimension(props.size) : props.width ?? 24,
		height: props.size ? getDimension(props.size) : props.height ?? 24
	});
	return Icon;
};
export { ZepIcon as t };
